import { getRoomsForList, updateRoomsInStore } from '../actions/calendarRoomActions';
import getRoomsInternalService from '../services/getRoomsInternalService';
import { orchestrator } from 'satcheljs';

export default orchestrator(getRoomsForList, async actionMessage => {
    let roomlistSmtp = actionMessage.roomlistSmtp;

    let response = await getRoomsInternalService(roomlistSmtp);

    let rooms = response.map(result => ({
        name: result.Id.Name,
        email: result.Id.EmailAddress,
    }));

    // Add Rooms to store, so they are rendered.
    updateRoomsInStore(rooms, actionMessage.viewStateId);
});
